import React, { Fragment } from 'react';
import { ExtendedFilterType, ExtendedKitchenFilterType } from 'pages/live-trips/types';
import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { KITCHEN_STATUS_TABS, STATUS_TABS } from 'utils/constants';
import { getCurrentTeam } from 'utils/role-config';
import { ENUM_STATUS } from 'utils/enum';
import useRoleContext from 'contexts/role.context';
import { ENUM_COKITCHEN_TEAM, ENUM_ROLE } from '@cokitchen/cokitchen-auth';

export type TabProps = {
  filter: ExtendedFilterType | ExtendedKitchenFilterType;
  setActiveFilter: (item: ExtendedFilterType) => void;
  numberOfItems?: Record<ExtendedFilterType, number>;
  disabled?: boolean;
};

export const StatusTabs: React.FC<TabProps> = ({
  setActiveFilter,
  filter,
  numberOfItems,
  disabled
}) => {
  const { role } = useRoleContext();

  const currentTeam = getCurrentTeam();
  const status: ExtendedKitchenFilterType[] | ExtendedFilterType[] =
    currentTeam === ENUM_COKITCHEN_TEAM.KITCHEN ? KITCHEN_STATUS_TABS : STATUS_TABS;
  const isCSAdminOrKitchen =
    role === ENUM_ROLE.CS_ADMIN ||
    role === ENUM_ROLE.CS_SUPER_ADMIN ||
    currentTeam === ENUM_COKITCHEN_TEAM.KITCHEN;

  const styles = { active: 'bg-[#E60A2B] text-white', inactive: 'bg-[#F5F5F5] text-[#858585]' };
  return (
    <Fragment>
      <div className='flex lg:hidden items-center'>
        <label htmlFor='' className='mr-3'>
          Active status:
        </label>
        <Dropdown
          content={
            <span
              className={`leading-[30px] flex items-center justify-center text-sm rounded-full px-5 cursor-pointer capitalize ${styles.inactive} !text-gray-6`}>
              {filter}
              {numberOfItems && filter !== 'All' && (
                <span
                  className={`text-[10px] ml-1 w-[18px] h-[18px] bg-red-5 text-white rounded-full inline-flex items-center justify-center`}>
                  {numberOfItems[filter]}
                </span>
              )}
            </span>
          }>
          <DropdownList className='min-w-[180px]'>
            {status?.map((s, i) => (
              <DropdownItem
                key={i}
                onClick={() => {
                  setActiveFilter(s);
                }}
                buttonClassName='capitalize py-2'>
                <Input className='text-sm' type='radio' checked={s === filter} readOnly label={s} />
                {numberOfItems && s !== 'All' && <span className='ml-1'>({numberOfItems[s]})</span>}
              </DropdownItem>
            ))}
          </DropdownList>
        </Dropdown>
      </div>
      <ul className='hidden lg:flex justify-start lg:overflow-x-auto'>
        {status?.map((item: ExtendedFilterType | ExtendedKitchenFilterType, index) => (
          <li
            key={index}
            onClick={() => {
              setActiveFilter(item as ExtendedFilterType);
            }}
            className={`leading-[40px] flex items-center justify-center rounded-full px-5 mr-4 last:mr-0 cursor-pointer capitalize ${
              disabled && 'opacity-50 cursor-not-allowed'
            } ${filter === item ? styles.active : styles.inactive} ${
              !isCSAdminOrKitchen && item === ENUM_STATUS.UNPAID ? 'hidden' : ''
            }`}>
            {item}
            {numberOfItems && item !== 'All' && (
              <span
                className={`text-xs ml-1 w-[24px] h-[24px] ${
                  filter === item ? 'bg-[#ff6776]' : 'bg-red-5'
                } text-white rounded-full inline-flex items-center justify-center`}>
                {numberOfItems[item as ExtendedFilterType]}
              </span>
            )}
          </li>
        ))}
      </ul>
    </Fragment>
  );
};
